import { render, staticRenderFns } from "./PromotionBookingsCard.vue?vue&type=template&id=424722dd&"
import script from "./PromotionBookingsCard.vue?vue&type=script&lang=js&"
export * from "./PromotionBookingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports